import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="check-box"
export default class extends Controller {
  connect() {}

  toggleAll(event) {
    const checked = event.target.checked;
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }
}
